export const DEFAULT_REQUESTER = 'A quien corresponda'
